export type BreakpointKey = keyof typeof Breakpoints;

export enum Breakpoints {
  None = 0,
  XS = 365,
  S = 600,
  M = 840,
  L = 1024,
  XL = 1280
}

export const breakpointKeys = Object.keys(Breakpoints).filter(v =>
  Number.isNaN(Number(v))
) as BreakpointKey[];
